// extracted by mini-css-extract-plugin
export default {"imgWrapper":"Buyer_imgWrapper__4mdfQ","img":"Buyer_img__Ssor+"};